import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo } from 'react';
import Button from 'react-bootstrap/Button';
import formatBytes from '../../../utils/FormatBytes';

function DocumentTable({ documentList, onDelete, onOpen, chosenDocument }) {
  const data = useMemo(() => documentList, [documentList]);
  const columns = useMemo(
    () => [
      {
        Header: 'Visningsnamn',
        accessor: 'displayName',
        className: 'p-3',
        style: { width: '35%' },
        Cell: ({ cell: { value } }) => (
          <div
            className='d-flex gap-1'
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: 'Filnamn',
        accessor: 'fileName',
        className: 'p-3',
        style: { width: '35%' },
        Cell: ({ cell: { value } }) => (
          <div
            className='d-flex gap-1'
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: 'Storlek',
        accessor: 'size',
        className: 'p-3',
        style: { width: '20%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{formatBytes(value)}</div>
        ),
      },
      {
        Header: '',
        accessor: 'delete',
        className: 'p-3',
        Cell: (props) => (
          <div
            className='d-flex gap-2 justify-content-end'
            role='button'
            onClick={() => {
              chosenDocument(props.row.original.fileUrl.split('/')[3]);
              onDelete();
            }}
          >
            <span className='material-symbols-outlined'>delete</span>
            <span>Radera</span>
          </div>
        ),
      },
      {
        Header: '',
        accessor: 'open',
        className: 'd-flex gap-1 justify-content-end',
        Cell: (props) => (
          <Button
            variant='outline-primary'
            className='d-flex align-items-center'
            onClick={() => {
              chosenDocument(props.row.original);
              onOpen(props.row.original.fileUrl);
            }}
          >
            <span
              className='material-symbols-outlined me-2'
              style={{ fontSize: '18px' }}
            >
              open_in_new
            </span>
            Öppna
          </Button>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <Table
      {...getTableProps()}
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className='table-borderless'
    >
      <thead className='bg-divider'>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className='bg-white'
              style={{ borderStyle: 'none' }}
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className}
                    style={cell.column.style}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default DocumentTable;
